import { CreateStore } from "../CreateStore";

export default CreateStore();
